import { ControllerAlert as Alert } from '@bymason-private/legacy-pattern-components';

export const TextToggleContent = ({ text, variant = 'standard' }: TextToggleContentProps) => (
  <Alert
    severity='info'
    variant={variant}
    icon={false}
    sx={{
      color: 'inherit',
      minWidth: 50,
      padding: '4px 10px 4px 8px',
      alignSelf: 'center',
      [`&.MuiAlert-${variant}${'Info'}`]: {
        color: (theme) => theme.palette.text.primary,
        backgroundColor: 'transparent',
        padding: 0,
        lineHeight: 'inherit',
        fontSize: 'inherit',
        justifyContent: 'center',
      },
      '& .MuiAlert-icon': { marginRight: '4px' },
    }}
  >
    {text}
  </Alert>
);

interface TextToggleContentProps {
  text: string;
  variant?: 'standard' | 'outlined';
}
